/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkPaymentResponseDto } from '../../models/bulk-payment-response-dto';

export interface SettlementControllerProcessBulkPayment$Params {

/**
 * 정산 ID
 */
  id: string;
}

export function settlementControllerProcessBulkPayment(http: HttpClient, rootUrl: string, params: SettlementControllerProcessBulkPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkPaymentResponseDto>> {
  const rb = new RequestBuilder(rootUrl, settlementControllerProcessBulkPayment.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkPaymentResponseDto>;
    })
  );
}

settlementControllerProcessBulkPayment.PATH = '/api/settlement/{id}/bulk-pay';
